const VIEW_USER_ID_KEY = "hrm_profile_view_user_id";

/** Persist viewed employee id for /users/view (not shown in the URL). */
export function setProfileViewUserId(userId) {
  if (userId == null || userId === "") return;
  try {
    sessionStorage.setItem(VIEW_USER_ID_KEY, String(userId));
  } catch {
    /* ignore quota / private mode */
  }
}

export function getProfileViewUserId() {
  try {
    return sessionStorage.getItem(VIEW_USER_ID_KEY) || null;
  } catch {
    return null;
  }
}

export function clearProfileViewUserId() {
  try {
    sessionStorage.removeItem(VIEW_USER_ID_KEY);
  } catch {
    /* ignore */
  }
}
